import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import "./Reports.css"
// import React from "react";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1914() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNewn BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    const [Borrow1914data, setBorrow1914data] = useState([]);
    const [thYearSelected, setThYearSelected] = useState(new Date().getFullYear() + 543)

    async function GetV1914() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV1914", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow1914data(data.dataenum)

    }

    const [Re1914yeardata, setRe1914yeardata] = React.useState([]);
    async function getR1914year() {
        const res = await fetch("/api/BorrowReports/getyear1914")
        const Re1914yeardata = await res.json()
        setRe1914yeardata(Re1914yeardata.dataenum)
        console.log(Re1914yeardata)
    }


    /* async function GetV1914() {
         const response1914 = await fetch("/api/BorrowReports/getV1914")
         const Borrow1914data = await response1914.json()
         setBorrow1914data(Borrow1914data.dataenum);
         console.log(Borrow1914data)
     }*/
    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ที่', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่คำขอ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เลขที่สัญญา', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผู้ขอกู้', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ประเภทกิจการ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนลูกจ้าง', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนหลักสูตร', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนรุ่น', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายชื่อหลักสูตร', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สาขาอาชีพ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่เริ่มฝึกอบรม/ทดสอบฯ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เดือนที่จบการฝึกหลักสูตรสุดท้าย', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'พ.ศ. ที่จบการฝึกหลักสูตรสุดท้าย', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนลูกจ้างที่ฝึกอบรม(คน)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วงเงิน(บาท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รวมวงเงินที่ได้รับการอนุมัติ(บาท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ครั้งที่และ ว/ด/ป ที่อนุกรรมการพิจารณาการให้กู้ยืมเงินฯ อนุมัติ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สพร./สพน.', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ฝึกอบรม(จำนวนคน)', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'การใช้จ่ายเงินกู้', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'จำนวนเงินกู้คงเหลือตามที่เบิกจ่ายจริง(บาท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, { text: 'ครบ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ไม่ครบ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ครบ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ไม่ครบ', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}],
    //     [{ text: '', fillColor: '#cccccc'}, { text: 'กย.3', colSpan: 18, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, { text: 'กย.6', colSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}],
    //     [{ text: 'ดำเนินการฝึกอบรมหรือทดสอบฝีมือแรงงานเสร็จสิ้น', colSpan: 24, fillColor: '#cccccc', bold: true, alignment: 'left' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]];
    //     Borrow1914data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.borrowNumber, alignment: 'right' }, { text: item.contactNumber, alignment: 'right' }, { text: item.employee, alignment: 'left' }, { text: item.businessType, alignment: 'left' }, { text: item.personTotal, alignment: 'right' }, { text: item.course, alignment: 'right' }, { text: item.class, alignment: 'right' }, { text: item.courseName, alignment: 'right' }, { text: item.lawOccupationName, alignment: 'right' }, { text: item.startDate, alignment: 'right' }, { text: item.endDate, alignment: 'right' }, { text: item.endDateMonth, alignment: 'right' }, { text: (Number(item.endDateYear) + 543), alignment: 'right' }, { text: item.employeeAmount, alignment: 'right' }, { text: item.amountApprove, alignment: 'right' }, { text: item.amountApprove, alignment: 'right' }, { text: 'ครั้งที่ ' + item.meetingNo + ' / ' + item.approveDate, alignment: 'right' }, { text: item.approveOfficerBy, alignment: 'right' }, { text: item.actualPersonFully, alignment: 'right' }, { text: item.actualPersonNot, alignment: 'right' }, { text: item.payFully, alignment: 'right' }, { text: item.payNot, alignment: 'right' }, { text: item.actualLeft, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'ทะเบียนข้อมูลสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน ตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545', bold: true, alignment: 'center', fontSize: 18 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: [23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1914')
    // }

    useEffect(() => {
        GetV1914()
        getR1914year()
    }, [thYearSelected])
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ประจำปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "10%", paddingTop: '2px', fontSize: '1.60rem' }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1914yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re1914yeardata?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                     
                    </Input>
                </div>
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1914?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1914?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1914?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1914?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}


                    <div className="report-wrapper">
                        <Table className="styled-table" bordered striped hover>
                            <thead className='styles-thead'>
                                <tr>
                                    <th rowSpan="2" className='text-center'>
                                        ที่
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        เลขที่คำขอ
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        เลขที่สัญญา
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        ผู้ขอกู้
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        ประเภทกิจการ
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        จำนวนลูกจ้าง
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        จำนวนหลักสูตร
                                    </th>
                                    <th rowSpan="2" className='text-center' >
                                        จำนวนรุ่น
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        รายชื่อหลักสูตร
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        สาขาอาชีพ
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        วันที่เริ่มฝึกอบรม/ทดสอบฯ
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        เดือนที่จบการฝึกหลักสูตรสุดท้าย
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        พ.ศ. ที่จบการฝึกหลักสูตรสุดท้าย
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        จำนวนลูกจ้างที่ฝึกอบรม(คน)
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        วงเงิน(บาท)
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        รวมวงเงินที่ได้รับการอนุมัติ(บาท)
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        ครั้งที่ และ ว/ด/ป ที่อนุกรรมการพิจารณาการให้กู้ยืมเงินฯ อนุมัติ
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        สพร./สนพ.
                                    </th>
                                    <th colSpan="2" className='text-center'>
                                        ฝึกอบรม(จำนวนคน)
                                    </th>
                                    <th colSpan="2" className='text-center'>
                                        การใช้จ่ายเงินกู้
                                    </th>
                                    <th rowSpan="2" className='text-center'>
                                        จำนวนเงินกู้ยืมคงเหลือตามที่เบิกจ่ายจริง(บาท)
                                    </th>

                                </tr>
                                <tr>
                                    <th className='text-center'>
                                        ครบ
                                    </th>
                                    <th className=' text-center'>
                                        ไม่ครบ
                                    </th>
                                    <th className='text-center'>
                                        ครบ
                                    </th>
                                    <th className=' text-center'>
                                        ไม่ครบ
                                    </th>
                                </tr>
                                <tr>
                                    <th className='text-center'>

                                    </th>
                                    <th colSpan="18" className='text-center'>
                                        กย.3
                                    </th>
                                    <th colSpan="6" className='text-center'>
                                        กย.6
                                    </th>

                                </tr>
                                <tr >
                                    <th colSpan="24" scope="row" className='text-start'>
                                        ดำเนินการฝึกอบรมหรือทดสอบฝีมือแรงงานเสร็จสิ้น
                                    </th>

                                </tr>
                            </thead>
                            <tbody> {Borrow1914data.map((item, i) => (
                                <tr>
                                    <th scope="row" className='text-center'>
                                        {i + 1}
                                    </th>
                                    <td className='text-end'>
                                        {item.borrowNumber}
                                    </td>
                                    <td className='text-end'>
                                        {item.contactNumber}
                                    </td>
                                    <td className='text-start'>
                                        {item.employee}
                                    </td>
                                    <td className='text-start'>
                                        {item.businessType}
                                    </td>
                                    <td className='text-end'>
                                        {item.personTotal}
                                    </td>
                                    <td className='text-end'>
                                        {item.course}
                                    </td>
                                    <td className='text-end'>
                                        {item.class}
                                    </td>
                                    <td className='text-end'>
                                        {item.courseName}
                                    </td>
                                    <td className='text-end'>
                                        {item.lawOccupationName}
                                    </td>
                                    <td className='text-end'>
                                        {item.startDate}
                                    </td>
                                    <td className='text-end'>
                                        {item.endDate}
                                    </td>
                                    <td className='text-end'>
                                        {item.endDateMonth}
                                    </td>
                                    <td className='text-end'>
                                        {item.endDateYear}
                                    </td>
                                    <td className='text-end'>
                                        {item.employeeAmount}
                                    </td>
                                    <td className='text-end'>
                                        {item.amountApprove}
                                    </td>
                                    <td className='text-end'>
                                        {item.amountApprove}
                                    </td>
                                    <td className='text-end'>
                                        ครั้งที่ {item.meetingNo + ' / ' + item.approveDate}
                                    </td>
                                    <td className='text-end'>
                                        {item.approveOfficerBy}
                                    </td>
                                    <td className='text-end'>
                                        {item.actualPersonFully}
                                    </td>
                                    <td className='text-end'>
                                        {item.actualPersonNot}
                                    </td>
                                    <td className='text-end'>
                                        {item.payFully}
                                    </td>
                                    <td className='text-end'>
                                        {item.payNot}
                                    </td>
                                    <td className='text-end'>
                                        {item.actualLeft}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    {/* <Table className="styled-table" bordered responsive striped hover>
                        <thead>
                            <tr>
                                <th rowSpan="2" className='text-center'>
                                    ที่
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    เลขที่คำขอ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    เลขที่สัญญา
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ผู้ขอกู้
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ประเภทกิจการ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวนลูกจ้าง
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวนหลักสูตร
                                </th>
                                <th rowSpan="2" className='text-center' >
                                    จำนวนรุ่น
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    รายชื่อหลักสูตร
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    สาขาอาชีพ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    วันที่เริ่มฝึกอบรม/ทดสอบฯ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    เดือนที่จบการฝึกหลักสูตรสุดท้าย
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    พ.ศ.ที่จบการฝึกหลักสูตรสุดท้าย
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวนลูกจ้างที่ฝึกอบรม(คน)
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    วงเงิน(บาท)
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    รวมวงเงินที่ได้รับการอนุมัติ(บาท)
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ครั้งที่และ ว/ด/ป ที่อนุกรรมการพิจารณาการให้กู้ยืมเงินฯ อนุมัติ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    สพร./สนพ.
                                </th>
                                <th colSpan="2" className='text-center'>
                                    ฝึกอบรม(จำนวนคน)
                                </th>
                                <th colSpan="2" className='text-center'>
                                    การใช้จ่ายเงินกู้
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวนเงินกู้ยืมคงเหลือตามที่เบิกจ่ายจริง(บาท)
                                </th>

                            </tr>
                            <tr>
                                <th className='text-center'>
                                    ครบ
                                </th>
                                <th className=' text-center'>
                                    ไม่ครบ
                                </th>
                                <th className='text-center'>
                                    ครบ
                                </th>
                                <th className=' text-center'>
                                    ไม่ครบ
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>

                                </th>
                                <th colSpan="18" className='text-center'>
                                    กย.3
                                </th>
                                <th colSpan="6" className='text-center'>
                                    กย.6
                                </th>

                            </tr>
                            <tr >
                                <th colSpan="24" scope="row">
                                    อยู่ระหว่างฝึกอบรมหรือทดสอบฝีมือแรงงานเสร็จสิ้น
                                </th>

                            </tr>
                        </thead>
                        <tbody> {Borrow1914data.map((item, i) => (

                            <tr>
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-center'>
                                    {item.borrowNumber}
                                </td>
                                <td className='text-center'>
                                    {item.contactNumber}
                                </td>
                                <td className='text-center'>
                                    {item.employee}
                                </td>
                                <td className='text-center'>
                                    {item.businessType}
                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>


                            </tr>
                        ))}
                        </tbody>
                    </Table> */}
                    </div>
            </div>

        </Container>
    );


}